export const getTextDirection = (text: string) =>
  /[\u0590-\u08FF\uFB1D-\uFDFD\uFE70-\uFEFC]/.test(text ?? "") ? "rtl" : "ltr";
